module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-28-6b5057b0ad3d00340508eb3c96fee2e6.jpg";